import APP_MAIN_PAGE_TYPE from "../types/AppMainPageType.js";

const AppMainPageAction = (appMainPage)=> {
   return {
      type: APP_MAIN_PAGE_TYPE,
      data: appMainPage
   };
};

export default AppMainPageAction;


